import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { useIsConnectEnabled } from "@/react/hooks/useIsConnectEnabled";
import { Connections } from "./Connections";
import { MemberDirectoryContent } from "./MemberDirectoryContent";
import { useMemberDirectorySettings } from "./useMemberDirectorySettings";

export const MemberDirectory = () => {
  const memberDirectorySettings = useMemberDirectorySettings();
  const isConnectEnabled = useIsConnectEnabled();
  const { path } = useRouteMatch();

  if (memberDirectorySettings.isLoading) {
    return null;
  }

  return (
    <Switch>
      <Route path={`${path}`} exact>
        <MemberDirectoryContent
          memberDirectorySettings={memberDirectorySettings}
        />
      </Route>
      {isConnectEnabled && (
        <Route path={`${path}/connections`} exact>
          <Connections />
        </Route>
      )}

      <Route render={() => <Redirect to={path} />} />
    </Switch>
  );
};

export default MemberDirectory;
